import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
`;

export const Label = styled.label`
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #444;
`;

export const TextInput = styled.input`
  font-size: 1rem;
  padding: 0.6rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  transition: border 0.2s ease;

  &:focus {
    border-color: #0070f3;
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  font-size: 1rem;
  padding: 0.6rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  resize: vertical;
  transition: border 0.2s ease;

  &:focus {
    border-color: #0070f3;
    outline: none;
  }
`;

export const NumberInput = styled.input`
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  width: 100%;
  max-width: 200px;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #0070f3;
    outline: none;
  }
`;